import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Card, Grid, Loader, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {parseTransferDetail, parseWarehouses} from '../../utils';
import ExcelReader from '../../../excelReader/components/index';
import FieldsSection from './fieldsSection';
import PrintModal from './modal/printModal';
import './location.scss';

class LocationEditor extends Component {
  constructor(props) {
    super(props);
    this.addLocation = this.addLocation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadFile = this.loadFile.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.WarehouseLocationsForm, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchWarehouses();
    this.props.fetchZonesList();
  }

  componentWillUnmount() {
    this.props.clearLocations();
  }

  addLocation() {
    this.props.addWarehouseLocation();
  }

  handleSubmit() {
    const {locations} = this.props;
    this.props.createWarehouseLocation({locations});
  }

  renderExcelImport() {
    const {creatingZones} = this.props;
    return (<ExcelReader onGetFile={this.loadFile} text='IMPORTAR' saving={creatingZones} />);
  }

  loadFile(data) {
    const {zones, warehouses, permissions} = this.props;
    const warehouseCodes = parseWarehouses(warehouses, permissions).map((item) => item.code);
    const detail = parseTransferDetail(data, warehouseCodes, zones);
    this.props.loadLocationsFile(detail);
  }

  renderFieldSection() {
    const {creatingZones, locations} = this.props;

    if (creatingZones) {
      return (
        <Card raised fluid>
          <Loader inline='centered' active>Guardando Información...</Loader>
        </Card>
      );
    }

    return (
      <FieldsSection locations={locations} />
    );
  }

  renderFieldsActions(creatingZones) {
    if (!creatingZones) {
      return (
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign='left'>
              <a className='link' onClick={this.addLocation}>
                <h4>+ AGREGAR REGISTRO</h4>
              </a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }

    return null;
  }

  render() {
    const {locationsToPrint, creatingZones} = this.props;

    return (
      <Form className='warehouse-location-editor'>
        <Card className='title' raised fluid>
          <Grid>
            <Grid.Row>
              <Grid.Column width={11} textAlign='left'>
                <PrintModal trigger={<h2>Creación de Ubicaciones</h2>} isOpen={locationsToPrint.length > 0} />
              </Grid.Column>
              <Grid.Column width={5} textAlign='right'>
                {this.renderExcelImport()}
                <Button type='submit' onClick={this.handleSubmit} disabled={creatingZones} primary>GUARDAR</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        {this.renderFieldSection()}
        {this.renderFieldsActions(creatingZones)}
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'creatingZones': state.warehouseLocation.loading,
    'loadingFile': state.warehouseLocation.loadingFile,
    'locations': state.warehouseLocation.locations,
    'warehouses': state.warehouses.list,
    'zones': state.zones.list,
    'locationsToPrint': state.warehouseLocation.locationsToPrint,
  };
};

const {
  fetchWarehouses,
  fetchZonesList,
  createWarehouseLocation,
  clearLocations,
  addWarehouseLocation,
  loadLocationsFile,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchWarehouses,
  fetchZonesList,
  navigateTo,
  createWarehouseLocation,
  clearLocations,
  addWarehouseLocation,
  loadLocationsFile,
})(LocationEditor);
